import Vue from "vue";
import {
  Toast,
  Lazyload,
  Dialog,
  Form,
  Field,
  Button,
  Cell,
  CellGroup,
  Icon,
  Tabbar,
  TabbarItem,
  Grid,
  GridItem,
  Search,
  List,
  Image,
  NavBar,
  Uploader,
  Overlay,
  Step,
  Steps,
  Sticky,
  Popup,
  Calendar,
  Picker,
  DatetimePicker,
  Empty,
  TreeSelect,
  Checkbox,
  Radio,
  CheckboxGroup,
  RadioGroup,
  Circle,
  Popover,
  Sidebar,
  SidebarItem,
  Image as VanImage,
  Badge,
  Collapse,
  CollapseItem,
  Tag,
  Swipe,
  SwipeItem,
  Divider,
  Tab,
  Tabs,
  DropdownMenu,
  DropdownItem,
  ImagePreview,
  NoticeBar,
  Pagination,
  Loading,
  ActionSheet,
  PullRefresh,
  ContactCard,
  Col,
  Row,
  Stepper,
  Rate,
  Slider,
  Area,
} from "vant";
Vue.use(Loading);
Vue.use(ContactCard );
Vue.use(Pagination);
Vue.use(Lazyload);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Search);
Vue.use(List);
Vue.use(Image);
Vue.use(Toast);
Vue.use(NavBar);
Vue.use(Uploader);
Vue.use(Overlay);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Sticky);
Vue.use(Popup);
Vue.use(Calendar);
Vue.use(Picker);
Vue.use(ImagePreview);
Vue.use(DatetimePicker);
Vue.use(Empty);
Vue.use(TreeSelect);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Circle);
Vue.use(Popover);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(VanImage);
Vue.use(Badge);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(NoticeBar);
Vue.use(Popover);
Vue.use(ActionSheet);
Vue.use(PullRefresh);
Vue.use(Col);
Vue.use(Row);
Vue.use(Icon);
Vue.use(Stepper);
Vue.use(Rate);
Vue.use(Slider);
Vue.use(Area);



// WEBPACK FOOTER //
// ./src/vant/vant.js